<template>
  <div class="myProjects" style="min-height: 100px;">
    <div>
      <el-row style="margin-top: 10px;">
        <el-col>
          <!-- <portal to="codeTypeMultiSelect">
            <el-select id="codeTypeFilter" key="codeTypeMultiSelect" v-loading="loading" element-loading-spinner="none" v-model="codeTypeMultiSelect" placeholder="" :clearable="true" multiple :collapse-tags="true" @remove-tag="handleCodeTypeMultiSelect()" @input="handleCodeTypeMultiSelect">
              <el-option v-for="item in codeTypeList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
            </el-select>
          </portal> -->
          <portal :to="`statusMultiSelect_${recordType}`">
            <el-select key="statusMultiSelect" v-loading="loading" element-loading-spinner="none" v-model="statusMultiSelect" placeholder="" :clearable="true" multiple :collapse-tags="true">
              <el-option v-for="item in statusList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
            </el-select>
          </portal>
          <el-button :disabled="getSelectedRecords().length === 0" :title="getSelectedRecords().length === 0 ? 'Use checkboxes on the left to select people to notify' : 'Send notifications'" class="hiaButton" plain round size="mini" @click="showNotifyModal = true">Notify Coders </el-button>

          <v-client-table key="ip" style="margin-top: 30px" class="hiaTable" ref="coderListInpatient" id="reviewListGrid" :data="projectsRebuttalsCalc" :columns="columns.filter(x => x !== 'codeTypes')" :options="options" v-loading="loading" element-loading-spinner="nucleus-loader">
            <!-- <template slot="filter__selectedCodeTypes">
              <portal-target name="codeTypeMultiSelect"> </portal-target>
            </template> -->
            <template slot="filter__status">
              <portal-target :name="`statusMultiSelect_${recordType}`"> </portal-target>
            </template>
            <template slot="selectedCodeTypes" slot-scope="props">
              <el-select :ref="`codeTypeSelect_${getRowKey(props.row)}`" :disabled="isCodeTypeSelectDisabled(props.row)" placeholder="All Code Types" element-loading-spinner="none" v-model="getRowCodeTypesComputed(props.row).value" :collapse-tags="true" :clearable="true" multiple @visible-change="handleCodeTypeDropdownVisible($event, props.row)">
                <el-option v-for="item in codeTypeList" :key="item.value" :label="item.value" :value="item.key"> </el-option>
              </el-select>
            </template>
            <template slot="coderCodeTypes" slot-scope="props">
              <div v-for="code in props.row.coderCodeTypes ? props.row.coderCodeTypes.split(',') : []" :key="code">
                {{ code }}
              </div>
            </template>
            <template slot="name" slot-scope="props">
              <div>{{ props.row.name ? props.row.name : `&lt;Not Specified&gt;` }}</div>
            </template>
            <template slot="h__selected">
              <input type="checkbox" id="rebuttalTrackingSelectAll" @click="localselectAll(recordType, 'coderListInpatient', $event)" />
            </template>
            <template slot="selected" slot-scope="props">
              <input :disabled="disableEmail(props.row)" type="checkbox" v-model="props.row.selected" @click="selectRecord(props.row, recordType, $event)" />
            </template>
            <template slot="rebuttalsLastSent" slot-scope="props">
              {{ props.row.rebuttalsLastSent ? formatDateTimeShort(props.row.rebuttalsLastSent) : '' }}
            </template>
            <template slot="emailAddress" slot-scope="props">
              <contactSelector v-if="props.row.coderId" :name="props.row.name" :contact="{ contactId: props.row.contactId, emailAddress: props.row.emailAddress }" type="checkbox" v-model="props.row.contactId" @input="updateCoder(props.row)" @selected="handleContactSelected(props.row, $event)" addContactRoleLabel="Rebuttal User" :addContactRoleId="21" :clientNumber="props.row.clientNumber" :confirmBeforeAssign="true"> </contactSelector>
              <div v-if="props.row.hiaCoderId">{{ props.row.emailAddress }}</div>
            </template>
            <template slot="accountStatus" slot-scope="props">
              <div style="display: flex; align-items: center;" v-html="getAccountStatus(props.row)"></div>
            </template>

            <template slot="status" slot-scope="props">
              <div style="display: flex; align-items: center;"><i :class="getStatusIcon(props.row.status)" :style="{ marginRight: '5px', fontSize: '18px', color: getStatusColor(props.row.status) }"></i>{{ props.row.status }}</div>
            </template>
          </v-client-table>
        </el-col>
      </el-row>
    </div>

    <div id="dialogs">
      <el-dialog width="50%" :title="projectsRebuttals.filter(x => x.selected).length > 0 ? 'Notify coders' : 'No Records Selected'" :visible.sync="showNotifyModal" :destroy-on-close="false">
        <div style="margin: 0px 0px 30px 0px;">
          <p style="margin: 0px 0px 5px 0px;">Select notify message:</p>
          <el-select :class="{ inputRedBorder: !notifyMessageSelected }" v-model="notifySelectedId" placeholder="Notify message (required)" style="margin-bottom: 12px;">
            <el-option v-for="item in compRebuttalsNotifications" :key="item.rebuttalsNotificationId" :label="item.title" :value="item.rebuttalsNotificationId"> </el-option>
          </el-select>

          <el-popover placement="bottom" width="420" trigger="click">
            <div style="text-align: left; word-break: break-word; max-height: 320px; overflow-y: auto;">
              <div v-if="notifySelectedTemplateBodyHtml" style="font-style: italic;" v-html="notifySelectedTemplateBodyHtml"></div>
              <div v-else-if="notifySelectedId" style="font-style: italic; color: #606266;">Default notify wording will be used (template body is blank).</div>
              <div v-if="customNotifyTrimForPreview" :style="(notifySelectedTemplateBodyHtml || notifySelectedId ? '' : '') + 'font-style: italic; white-space: pre-line;'">
                {{ customNotifyTrimForPreview }}
              </div>
            </div>
            <el-button :disabled="!notifyPreviewHasContent" style="float: right;" size="mini" slot="reference" plain round icon="el-icon-search">View notify text</el-button>
          </el-popover>

          <p style="margin: 16px 0px 8px 0px;">Additional message text (optional, appended below the notify message above):</p>
          <el-input
            v-model="customNotifyMessage"
            type="textarea"
            :rows="6"
            :maxlength="2000"
            show-word-limit
            :disabled="!notifyMessageSelected"
            :placeholder="notifyAdditionalPlaceholder"
          ></el-input>
        </div>
        <v-client-table v-loading="notifyLoading" element-loading-spinner="nucleus-loader" class="hiaTable" id="notifyPeople" ref="ipReviewListnotifyPeople" :data="notifyPeopleData" :columns="['accountStatus', 'name', 'emailAddress', 'totalRecordsReviewed', 'recordsWithFindings']" :options="notifyPeopleOptions">
          <template slot="accountStatus" slot-scope="props">
            <div v-html="getAccountStatus(props.row)"></div>
          </template>
        </v-client-table>
        <span slot="footer">
          <el-button-group>
            <el-button :disabled="notifyConfirmDisabled" @click="postNotifyPeople()" size="mini" plain round style="margin-right: 5px;">Confirm</el-button>
            <el-button
              :disabled="notifyLoading"
              @click="
                showNotifyModal = false
                notifySelectedId = null
                customNotifyMessage = ''
              "
              size="mini"
              plain
              round
              >Cancel</el-button
            >
          </el-button-group>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import dateHelper from '@/mixins/date-helper'
import hiaFilters from '@/mixins/hiaFilters'
import contactSelector from '@/components/contactSelector'
import hiaTable from '@/mixins/hiaTable'

export default {
  name: 'rebuttalTracking',
  props: ['recordType', 'projectId'],
  data: function() {
    return {
      codeTypeMultiSelect: [],
      codeTypeMultiSelectBackup: [],
      statusMultiSelect: [],
      rowCodeTypesComputed: {},
      openCodeTypeDropdowns: {},
      notifySelectedId: null,
      customNotifyMessage: '',
      loading: true,
      showNotifyModal: false,
      notifyLoading: false,
      notifyPostInFlight: false,
      columns: ['selected', 'accountStatus', 'name', 'emailAddress', 'coderCodeTypes', 'selectedCodeTypes', 'totalRecordsReviewed', 'recordsWithFindings', 'recordsWaitingForCoder', 'coderDisagrees', 'recordsWaitingForReviewer', 'recordsCompleted', 'rebuttalsLastSent', 'status'],
      options: {
        actionsPosition: 'right',
        actionsOptions: [],
        filterAlgorithm: {
          rebuttalsFirstSent: (row, query) => {
            const rowDate = this.formatDateTimeShort(row.rebuttalsFirstSent)
            return rowDate.includes(query)
          },
          rebuttalsLastSent: (row, query) => {
            const rowDate = this.formatDateTimeShort(row.rebuttalsFirstSent)
            return rowDate.includes(query)
          }
        },
        filterByColumn: true,
        columnsClasses: {
          recordTags: 'tagsCol',
          selectedCodeTypes: 'hide',
          coderCodeTypes: 'hide',
          status: 'statusCol',
          emailAddress: 'emailCol'
        },
        // filterable: ['consultantNumber', 'date', 'comments', 'serviceProvided', 'taskDescription'],
        filterable: ['accountStatus', 'name', 'emailAddress', 'coderCodeTypes', 'selectedCodeTypes', 'totalRecordsReviewed', 'recordsWithFindings', 'recordsWaitingForCoder', 'coderDisagrees', 'recordsWaitingForReviewer', 'recordsCompleted', 'rebuttalsLastSent'],
        sortable: ['accountStatus', 'name', 'emailAddress', 'coderCodeTypes', 'selectedCodeTypes', 'totalRecordsReviewed', 'recordsWithFindings', 'recordsWaitingForCoder', 'coderDisagrees', 'recordsWaitingForReviewer', 'recordsCompleted', 'rebuttalsLastSent', 'status'],
        headings: {
          codeTypes: 'Code Types',
          totalRecordsReviewed: 'Total Records Reviewed',
          recordsWithFindings: 'Records w/ Findings',
          rebuttalCount: 'Rebuttal Count',
          rebuttalActiveCount: 'Rebuttal Active Count',
          rebuttalRespondedCount: 'Rebuttal Responded Count',
          rebuttalsLastSent: 'Rebuttals Last Sent',
          rebuttalsReturned: 'Rebuttals Returned',
          rebuttalResponsesComplete: 'Rebuttal Responses Complete',
          emailAddress: 'Email',
          recordsWaitingForCoder: 'Records Waiting for Coder',
          recordsCompletedByCoder: 'Records Completed by Coder',
          recordsWaitingForReviewer: 'Records Waiting for Auditor',
          recordsCompletedByReviewer: 'Records Completed by Auditor',
          coderAgrees: 'Coder Agrees w/ Finding',
          coderDisagrees: 'Coder Disagrees w/ Finding',
          accountStatus: 'Account Status',
          recordsCompleted: 'Records Completed',
          coderCodeTypes: 'Code Types',
          selectedCodeTypes: 'Rebuttal Code Types',
          status: 'Status'
        },
        perPage: 15,
        texts: {
          filter: '',
          filterBy: '...'
        },
        highlightMatches: true,
        sortIcon: { is: 'none' }
      },
      notifyPeopleOptions: {
        filterByColumn: true,
        listColumns: {
          reviewLevel: []
        },
        orderBy: {
          column: 'patientNumber',
          ascending: true
        },
        headings: {
          patientNumber: 'Patient Number',
          agreeWithCodes: 'Coder Agrees',
          finalOutcome: 'Final Outcome',
          emailAddress: 'Email',
          name: 'Name',
          totalRecordsReviewed: 'Total Records Reviewed',
          accountStatus: 'Account Status',
          recordsWithFindings: 'Records w/ Findings',
          notifyMessage: 'Notify Message'
        },
        perPage: 25,
        texts: {
          filter: '',
          filterBy: '...'
        },
        highlightMatches: true,
        sortIcon: { is: 'none' },
        uniqueKey: 'coderId'
      },
      notifyMessageDropdown: [{ key: 1, value: 'Notify Message 1', message: 'Your coding review results are available in Nucleus.' }, { key: 2, value: 'Notify Message 2', message: 'Lorem ipsum dolor sit amet, usu at dicam dolore inimicus. Ad voluptua definiebas vim, te vim omnes postulant.' }],
      statusList: [{ key: 'Not Sent', value: 'Not Sent' }, { key: 'Waiting on Coder', value: 'Waiting on Coder' }, { key: 'Waiting on Auditor', value: 'Waiting on Auditor' }, { key: 'Waiting on Both', value: 'Waiting on Both' }, { key: 'Completed', value: 'Completed' }]
    }
  },
  mixins: [HiaAuthorization, hiaFilters, dateHelper, hiaTable],
  components: {
    contactSelector
  },
  methods: {
    ...mapActions('reviews/', ['GET_REVIEW_PROJECT', 'POST_NOTIFY_REBUTTAL_RECIPIENTS', 'PUT_PROJECTS_REBUTTALS', 'POST_PROJECTS_REBUTTALS']),
    ...mapActions('clientCoders/', ['PATCH_CODER_CONTACTID']),
    ...mapMutations('reviews/', ['SET_PROJECT_REBUTTALS_SELECTED', 'SET_PROJECTS_REBUTTALS', 'SET_PROJECTS_REBUTTALS_SELECTEDCODETYPES']),
    async initialize() {
      // user admin check
      this.loading = true
      let projectId = this.$route.params.id
      try {
        await this.GET_REVIEW_PROJECT(projectId)
        this.loading = false
        this.$nextTick(() => {
          this.options.columnsClasses.selectedCodeTypes = ['OP', 'AMB'].includes(this.recordType) ? 'allCodeTypes' : 'hide'
          this.options.columnsClasses.coderCodeTypes = ['OP', 'AMB'].includes(this.recordType) ? 'allCodeTypesLabel' : 'hide'
        })
      } catch (e) {
        this.$nextTick(() => {
          this.options.columnsClasses.selectedCodeTypes = ['OP', 'AMB'].includes(this.recordType) ? 'allCodeTypes' : 'hide'
          this.options.columnsClasses.coderCodeTypes = ['OP', 'AMB'].includes(this.recordType) ? 'allCodeTypesLabel' : 'hide'
        })
        this.$error('Error getting project')
      }
    },
    handleContactSelected(coder, contact) {
      coder.emailAddress = contact ? contact.emailAddress : null
      coder.contactId = contact ? contact.contactId : null
      coder.contactInactive = contact ? contact.inactive : false
      coder.auth0UserId = contact ? contact.auth0UserId : null
      let index = this.projectsRebuttals.findIndex(x => x.coderId === coder.coderId)
      this.$set(this.projectsRebuttals, index, coder)
    },
    updateCoder(coder) {
      this.loading = true
      let payload = {
        coderId: coder.coderId,
        contactId: coder.contactId,
        clientNumber: coder.clientNumber
      }
      this.PATCH_CODER_CONTACTID(payload).then(
        response => {
          this.loading = false
        },
        error => {
          console.log(error)
          this.loading = false
        }
      )
    },
    localselectAll(recordType, ref, e) {
      let checked = e.srcElement.checked
      let filteredRecords = []

      if (this.$refs[ref]) {
        filteredRecords = this.$refs[ref].allFilteredData
      }

      let recs = this.projectsRebuttals.filter(x => x.auth0UserId && !x.contactInactive && filteredRecords.some(y => y.coderId === x.coderId && y.totalRecordsReviewed > 0))
      hiaTable.selectAll(recs, checked)

      let payload = {
        recordType: recordType,
        projectsRebuttals: recs
      }

      this.SET_PROJECT_REBUTTALS_SELECTED(payload)
    },
    getSelectedRecords() {
      const selectedRows = this.projectsRebuttals.filter(x => x.selected)
      return selectedRows
    },
    selectRecord(row, recordType, e) {
      let checked = e.srcElement.checked
      row.selected = checked
      let payload = {
        recordType: recordType,
        projectsRebuttals: [row]
      }
      this.SET_PROJECT_REBUTTALS_SELECTED(payload)
    },
    async postNotifyPeople() {
      if (this.notifyPostInFlight) {
        return
      }
      this.notifyPostInFlight = true
      this.notifyLoading = true
      try {
        const mapped = this.notifyPeopleData.map(e => ({ ...e, selectedCodeTypes: JSON.stringify(e.selectedCodeTypes) }))
        // Same project+coder can appear more than once in projectsRebuttals (e.g. duplicate API rows); keep one row per coder (prefer highest projectRebuttalId), matching server notify.
        const byCoder = new Map()
        for (const row of mapped) {
          const key = row.coderId != null && row.coderId !== undefined ? row.coderId : `pr:${row.projectRebuttalId || 0}`
          const prev = byCoder.get(key)
          if (!prev || (row.projectRebuttalId || 0) > (prev.projectRebuttalId || 0)) {
            byCoder.set(key, row)
          }
        }
        let people = Array.from(byCoder.values())
        const customTrim = this.customNotifyMessage && this.customNotifyMessage.trim() ? this.customNotifyMessage.trim() : null
        let payload = {
          projectId: this.projectId,
          people: people,
          rebuttalsNotificationid: this.notifyRouteTemplateId,
          notificationTemplateId: this.notifySelectedId,
          customNotifyBody: customTrim
        }
        await this.POST_NOTIFY_REBUTTAL_RECIPIENTS(payload)
        this.showNotifyModal = false
        this.notifySelectedId = null
        this.customNotifyMessage = ''
        document.getElementById('rebuttalTrackingSelectAll').checked = false
      } catch (e) {
        let message
        if (e.response && e.response.data) {
          message = e.response.data.Message
        }
        this.$message({
          message: 'Error Notifying Rebuttal Recipients ' + message,
          type: 'error'
        })
      } finally {
        this.notifyLoading = false
        this.notifyPostInFlight = false
      }
    },
    handleCodeTypeMultiSelect(isOpenEvent) {
      // first reset it, this way we can remove filters and restore the original data
      this.SET_PROJECTS_REBUTTALS(JSON.parse(JSON.stringify(this.projectsRebuttalsBackup)))
      // then filter it
      if (this.codeTypeMultiSelect.length > 0) {
        this.SET_PROJECTS_REBUTTALS(this.projectsRebuttals.filter(x => x.recordType === this.recordType && this.codeTypeMultiSelect.some(y => (x.selectedCodeTypes ? x.selectedCodeTypes.some(z => z === y) : y === 'All'))))
        // this.codeTypeMultiSelectBackup = JSON.parse(JSON.stringify(this.codeTypeMultiSelect))
      }
    },
    handleStatusMultiSelect(isOpenEvent) {
      // first reset it, this way we can remove filters and restore the original data
      this.SET_PROJECTS_REBUTTALS(JSON.parse(JSON.stringify(this.projectsRebuttalsBackup)))
      // then filter it
      if (this.statusMultiSelect.length > 0) {
        this.SET_PROJECTS_REBUTTALS(this.projectsRebuttals.filter(x => x.recordType === this.recordType && this.statusMultiSelect.some(y => x.status === y)))
        // this.codeTypeMultiSelectBackup = JSON.parse(JSON.stringify(this.codeTypeMultiSelect))
      }
    },
    async putProjectRebuttals(row) {
      // update table if projectRebuttalId exists otherwise post update row
      let currentRow = JSON.parse(JSON.stringify(row))

      // if selectedCodeTypes contains null set it to null other leave alone
      // if (currentRow.selectedCodeTypes.includes(null) && currentRow.selectedCodeTypes.length > 1) {
      //   currentRow.selectedCodeTypes = [null]
      //   return
      // }
      // if (currentRow.selectedCodeTypes.includes(null)) {
      //   currentRow.selectedCodeTypes = [null]
      // }

      currentRow.selectedCodeTypes = JSON.stringify(currentRow.selectedCodeTypes)

      if (currentRow.projectRebuttalId) {
        // update table
        this.loading = true
        // currentRow.selectedCodeTypes = JSON.stringify(currentRow.selectedCodeTypes)
        await this.PUT_PROJECTS_REBUTTALS(currentRow)
        this.loading = false
      } else {
        // post new row
        this.loading = true
        // currentRow.selectedCodeTypes = JSON.stringify(row.currentRow)
        let payload = {
          recordType: this.recordType,
          projectsRebuttals: currentRow
        }
        await this.POST_PROJECTS_REBUTTALS(payload)
        this.loading = false
      }
    },
    isCodeTypeSelectDisabled(row) {
      return !row.auth0UserId
    },
    getRowKey(row) {
      return row.coderId || row.projectRebuttalId || `row_${row.name}`
    },
    handleCodeTypeDropdownVisible(isVisible, row) {
      const rowKey = this.getRowKey(row)
      // Track dropdown open/closed state
      this.$set(this.openCodeTypeDropdowns, rowKey, isVisible)

      // When dropdown closes, save any changes
      if (!isVisible) {
        this.$nextTick(() => {
          // Dropdown is now closed, save the changes
          this.putProjectRebuttals(row)
        })
      }
    },
    getRowCodeTypesComputed(row) {
      // Normalize selectedCodeTypes: API can send stringified arrays like "[]"
      let normalized = row.selectedCodeTypes
      if (typeof normalized === 'string') {
        try {
          normalized = JSON.parse(normalized)
        } catch (e) {
          normalized = []
        }
      }
      if (!Array.isArray(normalized)) {
        normalized = []
      }
      if (normalized !== row.selectedCodeTypes) {
        this.$set(row, 'selectedCodeTypes', normalized)
      }

      const self = this
      const rowKey = this.getRowKey(row)

      // Create or return cached computed property for this row
      // We need to recreate it if the row reference changes to ensure reactivity
      if (!this.rowCodeTypesComputed[rowKey] || this.rowCodeTypesComputed[rowKey]._row !== row) {
        // Create a computed property with getter and setter that v-model can bind to directly
        const computedObj = {
          _row: row, // Store row reference to detect changes
          get value() {
            // Return the actual reactive property
            return Array.isArray(row.selectedCodeTypes) ? row.selectedCodeTypes : []
          },
          set value(newValue) {
            // Update the row's selectedCodeTypes reactively
            const valueToSet = Array.isArray(newValue) ? newValue : []
            self.$set(row, 'selectedCodeTypes', valueToSet)
            // Only call putProjectRebuttals if dropdown is closed
            // Check the tracking object to see if dropdown is open
            if (!self.openCodeTypeDropdowns[rowKey]) {
              // Dropdown is closed, save immediately
              self.putProjectRebuttals(row)
            }
            // If dropdown is open, the save will happen in handleCodeTypeDropdownVisible when it closes
          }
        }
        this.$set(this.rowCodeTypesComputed, rowKey, computedObj)
      }

      // Return the computed property object - v-model will bind to it directly
      // Vue will use the get and set methods
      return this.rowCodeTypesComputed[rowKey]
    },
    disableEmail(row) {
      return !row.auth0UserId || row.contactInactive || row.totalRecordsReviewed === 0
    },
    getAccountStatus(row) {
      if (!row.auth0UserId) {
        return `<i style="font-size: 18px;margin-right: 5px; color: #e6a23c;"
              class="el-icon-warning-outline"></i><span>No Link</span>`
      }
      if (row.contactInactive) {
        return `<i style="font-size: 18px;margin-right: 5px; color: #e6a23c;"
              class="el-icon-warning-outline"></i><span>Contact Deactivated</span>`
      }
      if (row.totalRecordsReviewed === 0) {
        return `<i style="font-size: 18px;margin-right: 5px; color: #e6a23c;"
              class="el-icon-warning-outline"></i><span>No Completed Records</span>`
      }

      return `<i style="font-size: 18px;margin-right: 5px; color: #67c23a;"
              class="el-icon-circle-check"></i><span>Active</span>`
    },
    getStatusIcon(status) {
      if (status === 'Not Sent') {
        return 'el-icon-warning-outline'
      } else if (status === 'Waiting on Coder') {
        return 'el-icon-chat-dot-round'
      } else if (status === 'Waiting on Auditor') {
        return 'el-icon-chat-dot-round'
      } else if (status === 'Waiting on Both') {
        return 'el-icon-chat-dot-round'
      } else if (status === 'Completed') {
        return 'el-icon-circle-check'
      } else if (status === 'Not Complete') {
        return 'el-icon-refresh'
      }
    },
    getStatusColor(status) {
      if (status === 'Not Sent') {
        return '#e6a23c'
      } else if (status === 'Waiting on Coder') {
        return '#e6a23c'
      } else if (status === 'Waiting on Auditor') {
        return '#e6a23c'
      } else if (status === 'Waiting on Both') {
        return '#e6a23c'
      } else if (status === 'Completed') {
        return '#67c23a'
      } else if (status === 'Not Complete') {
        return '#e6a23c'
      }
    }
  },
  mounted: function() {
    this.initialize()
  },
  activated: function() {
    this.initialize()
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId', 'user']),
    ...mapState('reviews/', ['reviewProject', 'projectsRebuttals', 'rebuttalsNotifications', 'codeTypeList', 'projectsRebuttalsBackup']),
    projectsRebuttalsCalc() {
      if (this.statusMultiSelect.length > 0) {
        return this.projectsRebuttals.filter(x => x.recordType === this.recordType && this.statusMultiSelect.some(y => x.status === y))
      }
      return this.projectsRebuttals.filter(x => x.recordType === this.recordType)
    },
    notifyPeopleData() {
      if (this.projectsRebuttals.length) {
        let data = this.projectsRebuttalsCalc.filter(x => x.selected)
        return data
        // return data.map(x => {
        //   return {
        //     contactId: x.contactId,
        //     name: x.name,
        //     sender: this.user.email,
        //     recordCount: x.totalRecordsReviewed,
        //     recordsWithFindings: x.recordsWithFindings,
        //     emailAddress: x.emailAddress,
        //     projectId: this.projectId,
        //     coderId: x.coderId,
        //     hiaCoderId: x.hiaCoderId,
        //     projectRebuttalId: x.projectRebuttalId
        //   }
        // })
      }
      return []
    },
    compRebuttalsNotifications() {
      if (this.reviewProject.projectTypeId === 2) {
        return this.rebuttalsNotifications.filter(f => f.projectTypeId === 2)
      }
      return this.rebuttalsNotifications.filter(f => f.projectTypeId !== 2)
    },
    notifyMessageSelected() {
      return this.notifySelectedId != null && this.notifySelectedId !== ''
    },
    notifyAdditionalPlaceholder() {
      return this.notifyMessageSelected ? 'Enter optional additional text to append…' : 'Select a notify message above to enable additional text.'
    },
    notifySelectedTemplateBodyHtml() {
      if (!this.notifySelectedId || !this.rebuttalsNotifications || !this.rebuttalsNotifications.length) {
        return ''
      }
      const row = this.rebuttalsNotifications.find(f => f.rebuttalsNotificationId === this.notifySelectedId)
      return row && row.body ? row.body : ''
    },
    customNotifyTrimForPreview() {
      const c = this.customNotifyMessage && this.customNotifyMessage.trim()
      return c || ''
    },
    notifyPreviewHasContent() {
      return this.notifyMessageSelected
    },
    notifyRouteTemplateId() {
      return this.notifySelectedId
    },
    notifyConfirmDisabled() {
      if (this.notifyPostInFlight || this.notifyLoading) {
        return true
      }
      if (!this.notifyMessageSelected) {
        return true
      }
      if (!this.compRebuttalsNotifications.length) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
/* BUTTON ICONS*/
.linkIcon {
  font-size: 20px;
  float: left;
  height: 12px;
  margin: -3px 5px 0px 0px;
}

.inputRedBorder >>> input {
  border: 1px solid red !important;
  border-radius: 5px !important;
}

.coderIcon {
  font-size: 20px;
  float: left;
  height: 12px;
  margin: -3px 5px 0px 0px;
}

.nucleusAccessChildren >>> .el-form-item__label {
  width: 180px !important;
  margin-left: 20px;
}

#facilityList >>> .caret-wrapper,
#massUpdateTemplate >>> .caret-wrapper {
  display: none;
}

#facilityList >>> .el-form-item__label,
#massUpdateTemplate >>> .el-form-item__label {
  font-size: 12px !important;
}

#facilityList >>> .el-switch__core,
#massUpdateTemplate >>> .el-switch__core {
  height: 14px;
}

#facilityList >>> .el-switch__core:after,
#massUpdateTemplate >>> .el-switch__core:after {
  width: 10px;
  height: 10px;
}

#facilityList >>> .el-switch.is-checked .el-switch__core::after,
#massUpdateTemplate >>> .el-switch.is-checked .el-switch__core::after {
  left: 100%;
  margin-left: -11px;
}

>>> .tab .el-tabs__nav-wrap:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: #e4e7ed;
  z-index: 1;
  display: none;
}

>>> .allCodeTypes,
>>> .selectedCodeTypes {
  min-width: 145px;
}

>>> .allCodeTypes .el-tag {
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}

>>> .allCodeTypes .el-tag__close.el-icon-close {
  float: left;
  margin: -18px 0px 0px 44px;
}

>>> .allCodeTypes {
  min-width: 145px;
}

>>> .allCodeTypesLabel {
  width: 90px;
  min-width: 90px;
}

>>> .allCodeTypesLabel .el-tag {
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}

>>> .allCodeTypesLabel .el-tag__close.el-icon-close {
  float: left;
  margin: -18px 0px 0px 44px;
}

>>> .hide {
  display: none !important;
}

>>> .statusCol {
  min-width: 145px;
}

>>> .statusCol .el-tag {
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}

>>> .emailCol {
  min-width: 120px;
}
</style>
